/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_PendingInputs */

const cs_chat_attach_pending = /** @type {(inputs: Chat_Attach_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připraveno k odeslání`)
};

const en_chat_attach_pending = /** @type {(inputs: Chat_Attach_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to send`)
};

/**
* | output |
* | --- |
* | "Ready to send" |
*
* @param {Chat_Attach_PendingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_pending = /** @type {((inputs?: Chat_Attach_PendingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_PendingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_pending(inputs)
	return cs_chat_attach_pending(inputs)
});